// Rule applied: Use Hotwire (Turbo and Stimulus) for dynamic, SPA-like interactions

import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="stripe-id-modal"
export default class extends Controller {
  static targets = ["modal", "form", "paymentIdField", "reservationIdField"]

  connect() {
    // Add event listener for escape key
    document.addEventListener('keyup', this.handleKeyup.bind(this))
  }

  disconnect() {
    document.removeEventListener('keyup', this.handleKeyup.bind(this))
  }

  openModal(event) {
    // Get payment ID and reservation ID from the button's data attributes
    const paymentId = event.currentTarget.dataset.stripeIdModalPaymentIdParam
    const reservationId = event.currentTarget.dataset.stripeIdModalReservationIdParam
    
    // Set the form's hidden fields
    this.paymentIdFieldTarget.value = paymentId
    this.reservationIdFieldTarget.value = reservationId
    
    // Update the form's action URL
    this.formTarget.action = `/admin/reservations/${reservationId}/update_payment_stripe_id`
    
    // Show the modal
    this.modalTarget.classList.remove('hidden')
    
    // Prevent body scrolling
    document.body.classList.add('overflow-hidden')
  }

  closeModal(event) {
    if (event) {
      event.preventDefault()
    }
    
    // Hide the modal
    this.modalTarget.classList.add('hidden')
    
    // Re-enable body scrolling
    document.body.classList.remove('overflow-hidden')
  }

  handleKeyup(event) {
    // Close modal on escape key
    if (event.key === 'Escape') {
      this.closeModal()
    }
  }

  submitForm(event) {
    // Form will be submitted normally with Turbo
    // No need to prevent default
  }
}
